export const debounce = (func: (...arg: any) => void, timeout: number) => {
  let timer: ReturnType<typeof setTimeout>;

  const fn = (...arg: any) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(null, arg);
    }, timeout);
  };

  fn.cancel = () => {
    clearTimeout(timer);
  };

  return fn;
};
